import { useEffect, useRef, useState } from "react";
import { toast as sonner } from "sonner";
import { X, ChevronLeft, ChevronRight, ExternalLink } from "lucide-react";

// Sayfa içi fotoğraf galerisi (lightbox): ileri/geri (ok tuşları), kapat (Esc) — tuşlar üst katmana (hub Esc) sızmaz
export default function PhotoGallery({ images, start = 0, title = "", onClose }) {
  const [i, setI] = useState(start);
  const ref = useRef(null);
  const n = images.length;
  const prev = () => setI((k) => (k - 1 + n) % n);
  const next = () => setI((k) => (k + 1) % n);
  useEffect(() => { ref.current?.focus(); sonner.dismiss(); }, []);   // açık bildirimler galerinin üstünde kalmasın
  const onKey = (e) => {
    e.stopPropagation();
    if (e.key === "Escape") onClose();
    else if (e.key === "ArrowLeft") prev();
    else if (e.key === "ArrowRight") next();
  };
  const img = images[i];
  return (
    <div ref={ref} tabIndex={-1} onKeyDown={onKey} onClick={onClose} className="fixed inset-0 z-[60] bg-black/90 flex flex-col outline-none" data-testid="photo-gallery">
      <div className="flex items-center justify-between gap-3 px-4 py-3 text-white" onClick={(e) => e.stopPropagation()}>
        <div className="min-w-0"><div className="text-sm font-bold truncate">{title}</div><div className="text-xs text-white/70" data-testid="photo-gallery-counter">Fotoğraf {i + 1} / {n}</div></div>
        <div className="flex items-center gap-1">
          <a href={img.src} target="_blank" rel="noreferrer" className="p-2 rounded-md hover:bg-white/15" title="Yeni sekmede aç" data-testid="photo-gallery-open"><ExternalLink className="w-5 h-5" /></a>
          <button type="button" onClick={onClose} className="p-2 rounded-md hover:bg-white/15" aria-label="Kapat" data-testid="photo-gallery-close"><X className="w-6 h-6" /></button>
        </div>
      </div>
      <div className="relative flex-1 min-h-0 flex items-center justify-center px-14" onClick={(e) => e.stopPropagation()}>
        {n > 1 && <button type="button" onClick={prev} className="absolute left-3 top-1/2 -translate-y-1/2 p-3 rounded-full bg-white/10 hover:bg-white/25 text-white" aria-label="Önceki" data-testid="photo-gallery-prev"><ChevronLeft className="w-7 h-7" /></button>}
        <img src={img.src} alt={img.alt || `Fotoğraf ${i + 1}`} className="max-h-full max-w-full object-contain rounded-md shadow-2xl select-none" data-testid="photo-gallery-img" />
        {n > 1 && <button type="button" onClick={next} className="absolute right-3 top-1/2 -translate-y-1/2 p-3 rounded-full bg-white/10 hover:bg-white/25 text-white" aria-label="Sonraki" data-testid="photo-gallery-next"><ChevronRight className="w-7 h-7" /></button>}
      </div>
      {n > 1 && (
        <div className="flex items-center justify-center gap-2 py-3" onClick={(e) => e.stopPropagation()}>
          {images.map((im, k) => (
            <button type="button" key={im.src} onClick={() => setI(k)} className={`w-14 h-14 rounded-md overflow-hidden border-2 ${k === i ? "border-white" : "border-white/30 opacity-70 hover:opacity-100"}`} data-testid={`photo-gallery-thumb-${k}`}>
              <img src={im.src} alt="" className="w-full h-full object-cover" />
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
